// requires google maps to be loaded

const boundsToSearchArray = function(googleBoundsObj) {
  var latLonStr = googleBoundsObj.toString();
    latLonStr = latLonStr.replace(/[()\s]/g, "");
    var latLonArr = latLonStr.split(",");
    // latLonArr result from Google: [swLat, swLng, neLat, neLng]
    var latNW = latLonArr[2]; //same as neLat
    var lonNW = latLonArr[1]; //same as swLng
    var latSE = latLonArr[0]; //same as swLat
    var lonSE = latLonArr[3]; //same as neLng
    // search takes: [lat-nw,lon-nw, lat-se, lon-se]
    var requestArray = [latNW, lonNW, latSE, lonSE];
    var stringArr = "[" + requestArray + "]";
    return stringArr;
};

exports.boundsToSearchArray = boundsToSearchArray;

exports.getBoundsFromSearchArr = function(searchArr) {
  if (!google) {
    return;
  }
  var justString = searchArr.replace(/[\[\]]/g, "");
  var latLngBoundsArr = justString.split(",");

  var latNE = parseFloat(latLngBoundsArr[0]); //same as nwLat
  var lonSW = parseFloat(latLngBoundsArr[1]); //same as nwLng
  var latSW = parseFloat(latLngBoundsArr[2]); //same as seLat
  var lonNE = parseFloat(latLngBoundsArr[3]); //same as seLng

  var nE = new google.maps.LatLng(latNE, lonNE);
  var sW = new google.maps.LatLng(latSW, lonSW);
  var bounds = new google.maps.LatLngBounds(sW, nE);
  return bounds;
};

exports.getCenterFromSearchArr = function(searchArr) {
  var bounds = exports.getBoundsFromSearchArr(searchArr);
  var center = bounds.getCenter();
  return center;
};

exports.getBoundsZoomLevel = function(bounds, mapDim) {
    var WORLD_DIM = { height: 256, width: 256 };
    var ZOOM_MAX = 21;

    function latRad(lat) {
        var sin = Math.sin(lat * Math.PI / 180);
        var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
        return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
    }

    function zoom(mapPx, worldPx, fraction) {
        return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
    }

    var ne = bounds.getNorthEast();
    var sw = bounds.getSouthWest();

    var latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;

    var lngDiff = ne.lng() - sw.lng();
    var lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;

    var latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction);
    var lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction);

    return Math.min(latZoom, lngZoom, ZOOM_MAX);
};

exports.autoCompleteService = function autoCompleteService () {
  return new google.maps.places.AutocompleteService();
};

const geoCoder = function geoCoder () {
  return new google.maps.Geocoder();
};
exports.geoCoder = geoCoder;

exports.doAutoComplete = function doAutoComplete (placeId, location, callback) {
  const queryObj = {};
  return geoCoder().geocode({ placeId },
    (results) => {
      if (!results.length) {
        // This is a remenant from an old code, but want to keep it around,
        // because I do not know when it would happen, or how results can be 0 items
        console.warn('GEO results is 0', placeId);
      }
      queryObj.location = location.replace(/\,\s/g, '--').replace(/\s/g, '-');
      const geom = results[0].geometry;
      const POITypes = ['ROOFTOP', 'RANGE_INTERPOLATED'];
      if (-1 !== POITypes.indexOf(geom.location_type)) {
        const lat = geom.location.lat();
        const lng = geom.location.lng();
        queryObj.point_of_interest = `[${[lat, lng]}]`;
      } else if (geom.viewport) {
        queryObj.bbox_of_interest = boundsToSearchArray(geom.viewport);
      } else {
        callback({ error: true, results, queryObj });
      }
      callback({ error: false, results, queryObj });
    }
  );
};

exports.sessionToken = function sessionToken () {
  return new google.maps.places.AutocompleteSessionToken();
};
